import React from 'react'

const ReferencesBanner = () => {
    return (
        <div className='references-banner'>
            <div className='content'>
                <div className='title'><h1>REFERENCES</h1></div>
                <div className='subtitle'><strong>Trusted by Industry Leaders Worldwide</strong></div>
                <div className='description'><span>Discover the brands and businesses that trust us to deliver exceptional results. Below, you’ll find the logos of our valued partners and clients, showcasing the breadth and impact of our work across various industries.</span></div>
            </div>
        </div>
    )
}

export default ReferencesBanner
